import React, { useState } from 'react';
import "../CSS/popTemp.css"

function PopupTemp() {
  const [isOpen, setIsOpen] = useState(false);

  const handleAddActivity = () => {
    // Add activity logic here
    console.log('Add activity');
    closePopup();
  };

  const addActivity = () => {
    console.log("here")
  }

  const handleCancel = () => {
    closePopup();
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  const resourceList = [
    { name: 'Assignment', onClick: addActivity, image: 'assignment.png' },
    { name: 'Attendance', onClick: addActivity, image: 'attendance.png' },
    { name: 'Auto Attendance', onClick: addActivity, image: 'auto-attendance.png' },
    { name: 'Certificate', onClick: addActivity, image: 'certificate.png' },
    { name: 'Chat', onClick: addActivity, image: 'chat.png' },
    { name: 'Custom Certificate', onClick: addActivity, image: 'certificate.png' },
    { name: 'Database', onClick: addActivity, image: 'database.png' },
    { name: 'Feedback', onClick: addActivity, image: 'feedback.png' },
    { name: 'Forum', onClick: addActivity, image: 'forum.png' },
    { name: 'Glossary', onClick: addActivity, image: 'glossary.png' },
    { name: 'Quiz', onClick: addActivity, image: 'quiz.png' },
    { name: 'Survey', onClick: addActivity, image: 'survey.png' },
    { name: 'Training Event', onClick: addActivity, image: 'training-event.png' },
    { name: 'Wiki', onClick: addActivity, image: 'wiki.png' },
    { name: 'Workshop', onClick: addActivity, image: 'workshop.png' },
    { name: 'Zoom Meeting', onClick: addActivity, image: 'zoom-meeting.png' },
    { name: 'Book', onClick: addActivity, image: 'book.png' },
    { name: 'File', onClick: addActivity, image: 'file.png' },
    { name: 'Folder', onClick: addActivity, image: 'folder.png' },
    { name: 'IMS Content Package', onClick: addActivity, image: 'ims-content-package.png' },
    { name: 'Page', onClick: addActivity, image: 'page.png' },
    { name: 'URL', onClick: addActivity, image: 'url.png' },
  ];

  const addResource = (resource) => {
    resource.onClick();
    closePopup();
  };

  return (
    <>
      <button className="activity-title" onClick={() => setIsOpen(true)}>Add an activity or resource</button>
      {isOpen && (
        <div className="popup">
          <div className="popup-content">
            <div className="popup-header">
              <span className="title">Add an activity or resource</span>
              <button className="close-button" onClick={closePopup}>
                ×
              </button>
            </div>
            <div className="popup-body">
              <ul className="resource-list">
                {resourceList.map((resource, index) => (
                  <li key={index} className="resource-item" onClick={ resource.onClick}>
                    <label htmlFor={`resource-${index}`}>
                      <input type="radio" id={`resource-${index}`} />
                      <img src={require(`../../public/PopUpIcons/${resource.image}`)} alt={resource.name} />
                      <span>{resource.name}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
            <div className="popup-footer">
              <button className="add-button" onClick={handleAddActivity}>
                Add
              </button>
              <button className="cancel-button" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PopupTemp;